import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Popconfirm,
  Row,
  Select,
  Spin,
  Table,
} from 'antd';
import React from 'react';
import { sanitizeFieldName } from '../../util/methods';
import DocumentList from '../../components/DocumentList';
import moment from 'moment';
import MasterModal from "../../components/MasterModal";

const { TextArea } = Input;
let staSelected = false;

class Create extends React.Component {

  state = {
    showCancelButton: false,
    documentData: [],
    tableData: [],
  };

  componentDidMount() {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
    this.props.fetchOpenSta();
  }


  getDocumentData = (data) => {
    this.setState({ documentData: data });
  };

  cancelSta = (e) => {
    e.preventDefault();
    this.props.cancelSta({ sta: this.props.form.getFieldValue('sta') });
  };

  handleStaSelect() {
    this.setState({ showCancelButton: true });
  };

  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      const { documentData } = this.state;
      const data = Object.assign({}, values);
      if (documentData.length === 0) {
        data.documents = this.props && this.props.data && this.props.data.documents;
      } else {
        data.documents = documentData;
      }
      if (match.params && match.params.id) {
        this.props.onSubmit(data, match.params.id);
      } else {
        this.props.onSubmit(data);
      }
    });
  };

  updateReceivedQuantity = (item, e) => {
    this.props.updateReceivedQuantity(item, e.target.value);
  };
  updateCheckedValue = (qty, e) => {
    this.props.updateCheckedValue(e.target.value, e.target.checked, qty);
  };

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.data && (JSON.stringify(nextProps.data.sparePartTransaction) !== JSON.stringify(this.props.sparePartTransaction))) {
      const sptData = nextProps.data.sparePartTransaction;
      const arr = sptData.map(item => {
        return {
          key: item._id,
          name: item.type.name,
          quantity: item.quantity,
          checkbox: item,
          receivedQuantity: item.quantity,
        }
      });
      this.setState({ tableData: arr });
    }
    if (nextProps.sptListBySta && JSON.stringify(nextProps.sptListBySta.spareParts) !== JSON.stringify(this.props.sptListBySta.spareParts)) {
      const staData = nextProps.sptListBySta.spareParts.filter(item => item.sparePartTransaction.status === 'INTRANSIT');
      const arr = staData.map(item => {
        return {
          key: item.sparePartTransaction._id,
          name: item.sparePart.name,
          quantity: item.sparePartTransaction.quantity,
          checkbox: item.sparePartTransaction,
          receivedQuantity: item.sparePartTransaction,
        }
      });
      this.setState({ tableData: arr });
    }
  }

  sparePartTable() {
    const { data, title, sptListBySta } = this.props;
    const { tableData } = this.state;
    const dataSource = [];
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: 'quantity',
      },
      {
        title: 'Received',
        dataIndex: 'checkbox',
        key: 'checkbox',
        render: (item) => <Checkbox key={item._id} onChange={this.updateCheckedValue.bind(this, item.quantity)}
          value={item._id}> </Checkbox>,
      },
      {
        title: 'Received Quantity',
        dataIndex: 'receivedQuantity',
        key: 'receivedQuantity',
        render: (item) => {
          return title === 'EDIT' ? <Input value={item} disabled /> : <Input value={item.quantity} disabled />
          // return title === 'EDIT' ? <Input value={item} disabled/> :
          //   <Input key={item._id} onChange={this.updateReceivedQuantity.bind(this, item._id)}/>
        },
      },
    ];
    return <Table columns={columns} dataSource={tableData} pagination={false} />;
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, loading, filters, title, resource, form, openSta } = this.props;
    const { showCancelButton } = this.state;
    let openAtaData = openSta;
    // openAtaData = filters['sta'] && filters['sta']['data'] && filters['sta']['data']['data'].filter(item => {
    //   return item.staStatus === 'Open';
    // });

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} type="flex" align="bottom">
              <Col span={12}>
                {(filters['receiptStatus'] && title === 'CREATE') ? null :
                  <Form.Item key={'receiptStatus'} label={'Receipt Status'}>
                    {getFieldDecorator('receiptStatus', {
                      initialValue: data && data.receiptStatus,
                    })(<Input disabled />)
                    }
                  </Form.Item>
                }
                <Form.Item key={'sta'} label={'Select STA'}>
                  {getFieldDecorator('sta', {
                    rules: [{ required: true, message: `STA is required!` }],
                    initialValue: data && data.sta && data.sta.staNo,
                  })(
                    <Select
                      showSearch
                      style={{ width: '100%' }}
                      placeholder="Select STA"
                      onFocus={() => {
                        staSelected = true;
                      }}
                      filterOption={(input, option) =>
                        (option.props.children + '').toLowerCase().indexOf((input + '').toLowerCase()) >= 0
                      }
                      onChange={this.handleStaSelect.bind(this)}
                      onSelect={this.props.fetchSptListBySta}
                      disabled={(title === 'EDIT' && filters['sta'] && filters['sta'].options.disabledOnEdit) || false}
                    >
                      {openAtaData && openAtaData.map(item =>
                        <Select.Option key={item._id} value={item._id}>{item.staNo}</Select.Option>)}
                    </Select>)}
                </Form.Item>
              </Col>
              {
                title === 'CREATE' && showCancelButton && <Col span={12} style={{ paddingBottom: '12px' }}>
                  <Popconfirm
                    title="Are you sure you want to delete this record?"
                    onConfirm={this.cancelSta}
                    onCancel={() => {
                      message.error('Cancelled');
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button type="primary" className="gx-mb-0" htmlType={'button'} loading={loading}>CANCEL STA</Button>
                  </Popconfirm>

                </Col>
              }
            </Row>

            {
              (title === 'EDIT') && <Form.Item key={'sraNo'} label={'SRA Number'}>
                {getFieldDecorator('sraNo', {
                  rules: [{ required: false, message: `SRA Number is required!` }],
                  initialValue: ((data && data.sraNo) || ''),
                })(<Input disabled />)
                }
              </Form.Item>
            }

            <Form.Item key={'sparePartTransaction'} label={'Spare Parts'}>
              {getFieldDecorator('sparePartTransaction', {
                rules: [{ required: true, message: `sparePartTransaction is required!` }],
                initialValue: (data && data.sparePartTransaction && data.sparePartTransaction.length) ? data.sparePartTransaction.map(field => field._id) : [],
              })(<Checkbox.Group style={{ width: '100%' }}
                disabled={(title === 'EDIT' && filters['sparePartTransaction'] && filters['sparePartTransaction'].options.disabledOnEdit) || false}>
                {this.sparePartTable()}
              </Checkbox.Group>)
              }
            </Form.Item>

            <Form.Item key={'grnDate'} label={'GRN Date'}>
              {getFieldDecorator('grnDate', {
                rules: [{ required: true, message: `GRN Date is required!` }],
                initialValue: data && data.grnDate && moment(data.grnDate),
              })(<DatePicker
                disabled={(title === 'EDIT' && filters['grnDate'] && filters['grnDate'].options.disabledOnEdit) || false} />)
              }
            </Form.Item>

            <Form.Item key={'grnNo'} label={'Manual GRN Number'}>
              {getFieldDecorator('grnNo', {
                rules: [{ required: true, message: `Manual GRN Number is required!` }],
                initialValue: data && data.grnNo,
              })(<Input
                disabled={(title === 'EDIT' && filters['grnNo'] && filters['grnNo'].options.disabledOnEdit) || false} />)
              }
            </Form.Item>

            <Form.Item key={'otherCost'} label={'Other Cost'}>
              {getFieldDecorator('otherCost', {
                rules: [{ required: false, message: `Other Cost is required!` }],
                initialValue: data && data.otherCost,
              })(<Input type='number'
                onWheel={event => event.currentTarget.blur()}
                placeholder={'Other Cost'}
                style={{ marginRight: 8 }}
                disabled={(title === 'EDIT' && filters['otherCost'] && filters['otherCost'].options.disabledOnEdit) || false} />)
              }
            </Form.Item>

            <Form.Item key={'otherCostDetails'} label={'Other Cost Details'}>
              {getFieldDecorator('otherCostDetails', {
                rules: [{ required: false, message: `Other Cost Details is required!` }],
                initialValue: data && data.otherCostDetails,
              })(<Input
                placeholder={'Other Cost Details'}
                disabled={(title === 'EDIT' && filters['otherCostDetails'] && filters['otherCostDetails'].options.disabledOnEdit) || false} />)
              }
            </Form.Item>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item key={'receivedBy.date'} label={'Received By Date'}>
                  {getFieldDecorator('receivedBy.date', {
                    rules: [{ required: true, message: `Received By Date is required!` }],
                    initialValue: data && data.receivedBy && data.receivedBy.date && moment(data.receivedBy.date),
                  })(<DatePicker showTime
                    disabled={(title === 'EDIT' && filters['receivedBy.date'] && filters['receivedBy.date'].options.disabledOnEdit) || false} />)}
                </Form.Item>
              </Col>
              <Col span={14}>
                <Form.Item key={'receivedBy.name'} label={'Received By Name'}>
                  {getFieldDecorator('receivedBy.name', {
                    rules: [{ required: true, message: `Received By Name is required!` }],
                    initialValue: data && data.receivedBy && data.receivedBy.name && data.receivedBy.name._id,
                  })(<Select
                    showSearch
                    style={{ width: '80%' }}
                    placeholder="Please select"
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    disabled={(title === 'EDIT' && filters['receivedBy.name'] && filters['receivedBy.name'].options.disabledOnEdit) || false}
                  >
                    {filters['receivedBy.name'] && filters['receivedBy.name']['data'] && filters['receivedBy.name']['data']['data'].map(item =>
                      <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                  </Select>)}
                  {
                    filters['receivedBy.name'] && filters['receivedBy.name'].options && filters['receivedBy.name'].options.master ?
                      <MasterModal resource={resource} item={filters['receivedBy.name'].options.ref}
                        title={'CREATE'} /> : ''
                  }
                </Form.Item>
              </Col>
            </Row>

            <Form.Item key={'remarks'} label={'Remarks'}>
              {getFieldDecorator('remarks', { initialValue: data && data.remarks })(<TextArea disabled={title === 'VIEW'}
                rows={3} />)}
            </Form.Item>
            {filters && filters.documents &&
              <DocumentList history={this.props.history} match={this.props.match} key={filters.documents}
                item={filters.documents} form={form} data={data.documents}
                getDocumentData={this.getDocumentData}
                isDisabled={(title === 'EDIT' && filters['documents'] && filters['documents'].options.disabledOnEdit) || false} />}

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}
                disabled={title === 'EDIT'}>
                {title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
